import React from 'react';

const Decisions: React.FC = () => {
    return (
        <div className="decisions">
            <div className="container">
                <h2 className="t-two decisions__title">
                    Надежное решение для юридических лиц и индивидуальных предпринимателей
                </h2>
                <div className="row gx-md-6 gy-3 gx-svm-3 gy-sm-6 decisions__row">
                    <div className="col-lg-6 col-sm-12 decisions__item _two">
                        <div className="d-flex flex-column align-items-start decisions__i-body justify-content-end">
                            <div className="fw-bold decisions__i-title">
                                Несколько корзин
                            </div>
                            <p className="decisions__i-text">
                                Создавайте корзины для разных организаций или откладывайте товары до следующей покупки,
                                не удаляя их из корзины
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-12 decisions__item _two">
                        <div className="d-flex flex-column align-items-start decisions__i-body justify-content-end">
                            <div className="fw-bold decisions__i-title">
                                Повтор заказов
                            </div>
                            <p className="decisions__i-text">
                                Не собирайте корзину заново – воспользуйтесь опцией «Повторить заказ» в разделе «Мои
                                заказы»
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-12 decisions__item _two">
                        <div className="d-flex flex-column align-items-start decisions__i-body justify-content-end">
                            <div className="fw-bold decisions__i-title">
                                Персональный менеджер
                            </div>
                            <p className="decisions__i-text">
                                Персональный менеджер всегда будет на связи, чтобы проконсультировать по наличию и
                                помочь оформить заказ
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-12 decisions__item _two">
                        <div className="d-flex flex-column align-items-start decisions__i-body justify-content-end">
                            <div className="fw-bold decisions__i-title">
                                Выгодные цены
                            </div>
                            <p className="decisions__i-text">
                                Мы понимаем сложность современного бизнеса. Поэтому регулярно проводим для наших клиентов
                                маркетинговые активности
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Decisions;